import type { RouteLocationNormalizedLoaded } from 'vue-router'

export const NOT_FOUND_ROUTE_NAME = 'not-found'

/**
 * Resolve o layout global da rota. A rota 404 não tem meta.layout de propósito:
 * autenticado mantém o shell do dashboard, anônimo vê a tela cheia (empty).
 */
export function resolveLayout(
  route: Pick<RouteLocationNormalizedLoaded, 'name' | 'meta'>,
  authenticated: boolean
): string {
  if (route.name === NOT_FOUND_ROUTE_NAME) {
    return authenticated ? 'default-layout' : 'empty-layout'
  }

  return `${route.meta.layout || 'default'}-layout`
}
